import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared QueryClient, owned here (not main.jsx) so non-React
 * modules — the auth store in particular — can import it without a
 * circular dependency. The auth store wipes it at every auth boundary:
 * on a shared front-desk workstation, sign-out/sign-in briefly rendered
 * the PREVIOUS account's For You queues and counts until a manual
 * reload, because logout cleared tokens but left the query cache
 * (Codex feature audit 2026-09-09, finding 1). A full clear() covers
 * every user/role/tenant-sensitive query at once.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
